import { Component } from "react";
import "../styles/footer.css";
import { Link } from "react-router-dom";

class Footer extends Component {
  render() {
    return (
      <>
        <footer
          className="py-5"
          style={{
            background:
              "linear-gradient(to bottom, #ffffff 0%, #edc6bb28 100%)",
          }}
        >
          <div className="container py-lg-4">
            <div className="row g-5 mb-5">
              <div className="col-lg-3 text-center text-lg-start">
                <img
                  src="/assets/logos/xlp-logo.png"
                  alt="XLP Logo"
                  height="60"
                  className="mb-4"
                />
              </div>

              <div className="col-6 col-lg-3">
                <h5 className="h6 fw-bold mb-3 text-dark">Company</h5>
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li>
                    <Link
                      to="/"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/xlp_for_schools_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      For Schools
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/channel_with_us_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Join Us
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-6 col-lg-3">
                <h5 className="h6 fw-bold mb-3 text-dark">For Students</h5>
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li>
                    <Link
                      to="/xlp_workshops"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Workshops
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/xlp_individual_students_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      For Individual Student
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-12 col-lg-3 mt-4 mt-lg-0">
                {/* <h5 className="h6 fw-bold mb-3 text-dark">Products</h5> */}
                {/* <ul className="list-unstyled d-flex flex-column gap-2">
                  <li>
                    <Link
                      to="/shop_now_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Shop Now
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products_shipping_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Shipping
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products_returns_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Returns
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products_cancellation_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Order Cancellation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact_screen"
                      className="text-secondary text-decoration-none custom-hover"
                    >
                      Contact
                    </Link>
                  </li>
                </ul> */}
              </div>
            </div>

            <div className="text-center text-muted small border-top pt-4">
              <p className="mb-0">
                Copyright &copy; 2026 XLP. All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
